export const FEATURES = [
  {
    id: 'checkin',
    title: 'Two-Minute Check-ins',
    description: 'A quick daily check-in to track what triggers your hard days—mood, energy, sleep—without pressure or guilt.',
    icon: 'heart-outline',
    color: '#FF6B6B',
    gradient: ['#FF6B6B', '#FF8E8E'],
  },
  {
    id: 'ai',
    title: 'AI Companion',
    description: 'Mia listens when you need to vent, helps you spot what works, and suggests coping strategies that fit your day.',
    icon: 'chatbubble-ellipses-outline',
    color: '#6C63FF',
    gradient: ['#6C63FF', '#8B85FF'],
  },
  {
    id: 'insights',
    title: 'Pattern Insights',
    description: 'See what actually triggers your bad weeks—sleep, stress, skipped meals—so you can bounce back faster.',
    icon: 'analytics-outline',
    color: '#4D96FF',
    gradient: ['#4D96FF', '#6BA8FF'],
  },
  {
    id: 'journal',
    title: 'Guided Journaling',
    description: 'Write when you need to process. AI prompts help you figure out what is going on without staring at a blank page.',
    icon: 'book-outline',
    color: '#FF8E53',
    gradient: ['#FF8E53', '#FFAB76'],
  },
  {
    id: 'coping',
    title: '100+ Coping Skills',
    description: 'Evidence-based techniques for anxiety, burnout, sleep issues—find what works for you and track what helps.',
    icon: 'leaf-outline',
    color: '#6BCB77',
    gradient: ['#6BCB77', '#8DD694'],
  },
  {
    id: 'badges',
    title: 'Streaks & Badges',
    description: 'Small wins add up. Track your consistency, earn badges, and see your progress without the pressure.',
    icon: 'trophy-outline',
    color: '#FFD93D',
    gradient: ['#FFD93D', '#FFE566'],
  },
  {
    id: 'bingo',
    title: 'Coping Skills Bingo',
    description: 'A fun way to try new coping techniques—complete a line or fill the card to discover what actually helps you.',
    icon: 'grid-outline',
    color: '#E040FB',
    gradient: ['#E040FB', '#EA80FC'],
  },
];

export const FAQ_ITEMS = [
  {
    question: 'Is my data private?',
    answer: 'Yes. Your journal entries and mood data are encrypted and never sold. AI chats are not used to train models. You can export or delete your data anytime.',
  },
  {
    question: 'Do I have to check in every day?',
    answer: 'No pressure. Check in when you want—two taps is all it takes. The app works whether you log daily or just when something feels off.',
  },
  {
    question: 'What does $19.99 include?',
    answer: 'Full access to everything: AI companion, 100+ coping skills, pattern insights, journaling, bingo, and all future updates. One payment, no subscriptions.',
  },
  {
    question: 'Can I try it first?',
    answer: 'You can explore the landing page and see the features. After signup, full access requires the one-time payment—no hidden trials or surprise charges.',
  },
];

